import React from 'react'

import yn from 'yn'

import arrowDown from '../../../assets/icons/arrow-down.svg'
import arrowUp from '../../../assets/icons/arrow-up.svg'

const BkFlowRoomCardDescriptionButtons = props => {
	const {
		hotelLabels,
		isMobileButtons,
		hasValidSpecialPackages,
		specialPackagesExpanded,
		roomDetailsExpanded,
		handleSpecialPackagesAccordion,
		handleRoomDetailsAccordion,
	} = props

	return (
		<div className={ isMobileButtons ?
			'bk-flow-room__card-description-buttons mobile row center-xs start-md'
		:
			'bk-flow-room__card-description-buttons desktop row center-xs start-md'
		}>

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_SPECIAL_PACKAGES) && hasValidSpecialPackages &&
				<button
					className={ specialPackagesExpanded ?
						"bk-flow-room__card-description-special-offers-btn btn btn-transparent active row center-xs middle-xs start-lg"
					: roomDetailsExpanded ?
						"bk-flow-room__card-description-special-offers-btn btn btn-transparent inactive row center-xs middle-xs start-lg"
					:
						"bk-flow-room__card-description-special-offers-btn btn btn-transparent row center-xs middle-xs start-lg"
					}
					onClick={ () => handleSpecialPackagesAccordion() }
				>
					{ hotelLabels.roomOffers ? hotelLabels.roomOffers : 'Room Offers'}

					<div className="bk-flow-room__card-description-icons mobile">
						<i className="material-icons ">{ specialPackagesExpanded ? 'remove' : 'add' }</i>
					</div>

					<div className="bk-flow-room__card-description-icons desktop">
						<img
							src={specialPackagesExpanded ? arrowUp : arrowDown}
							alt={specialPackagesExpanded ? 'Close Room Offers' : 'Open Room Offers'}
						/>
					</div>
				</button>
			}

			{
				yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION) &&
				<button
					className={ roomDetailsExpanded ?
						"bk-flow-room__card-description-room-details-btn btn btn-transparent active row center-xs middle-xs start-lg"
					: specialPackagesExpanded ?
						"bk-flow-room__card-description-room-details-btn btn btn-transparent inactive row center-xs middle-xs start-lg"
					:
						"bk-flow-room__card-description-room-details-btn btn btn-transparent row center-xs middle-xs start-lg"
					}
					onClick={ () => handleRoomDetailsAccordion() }
				>
					{ hotelLabels.viewRoomDetails ? hotelLabels.viewRoomDetails : 'View Room Details' }

					<span className="bk-flow-room__card-description-icons mobile">
						<i className="material-icons ">{ roomDetailsExpanded ? 'remove' : 'add' }</i>
					</span>

					<span className="bk-flow-room__card-description-icons desktop">
						<img
							src={roomDetailsExpanded ? arrowUp : arrowDown}
							alt={roomDetailsExpanded ? 'Close Room Details' : 'Open Room Details'}
						/>
					</span>
				</button>
			}

		</div>
	)
}

export default BkFlowRoomCardDescriptionButtons


// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardDescriptionButtons.js